<div class="row">
    <div class="col-sm-6">
        <h4>Lista de bibliografías</h4>
    </div>

    <ng-container *ngIf="accessMP===true">
        <div class="col-md-6">
            <div class="d-flex justify-content-end">
                <a [routerLink]="['../../addAll', idtier3Selected]" class="btn-add">
                    <i class="fa fa-plus px-2"></i> Agregar bloque
                </a>
                <a [routerLink]="['../../add', idtier3Selected]" class="btn-add">
                    <i class="fa fa-plus px-2"></i> Agregar nuevo
                </a>
            </div>
        </div>
    </ng-container>

</div>
<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <ng-container *ngIf="!isBlockedTier3">
                        <th scope="col">
                            <div class="dropdown d-inline-flex align-items-center">
                                <input type="checkbox" class="form-check-input" (change)="toggleSelectAll($event)"
                                    [checked]="isAllSelected()" />
                                <i class="bi bi-three-dots-vertical dropdown-toggle" id="dropdownActions"
                                    data-bs-toggle="dropdown" aria-expanded="false"></i>
                                <ul class="dropdown-menu" aria-labelledby="dropdownActions">
                                    <li>
                                        <a class="dropdown-item" (click)="inactiveBiblioBlock()">Cambiar estado</a>
                                    </li>
                                </ul>
                            </div>
                        </th>
                    </ng-container>
                    <th scope="col">N°</th>
                    <th scope="col">Orden</th>
                    <th scope="col">Contenido</th>
                    <th scope="col">URL fuente</th>
                    <th scope="col">Estado</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let o of biblio; let i = index">
                    <ng-container *ngIf="!isBlockedTier3">
                        <td class="text-center">
                            <input type="checkbox" [(ngModel)]="o.selected" (change)="updateSelectedIds(o)" />
                        </td>
                    </ng-container>
                    <td>{{ i + 1 }}</td>
                    <td>{{ o.order }}</td>
                    <td>{{ o.content }}</td>
                    <td>{{ o.urlsource }}</td>
                    <td class="text-center">
                        <div class="label-active" *ngIf="o.status">ACTIVO</div>
                        <div class="label-inactive" *ngIf="!o.status">INACTIVO</div>
                    </td>
                    <ng-container *ngIf="accessME===true">
                        <td class="text-center"><a class="a-icon" [routerLink]="['/adm/bibliografia/edit', o.id]"><i
                                    class="fa fa-pencil i-icon"></i></a></td>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true && !isBlockedTier3">
                        <td class="text-center"><a class="a-icon" (click)="deleteBiblio(o.id, i+1)"><i
                                    class="fa fa-trash i-icon"></i></a></td>
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </div>
</div>